import * as Types from '../../declarations'
import SectionHeader from './components/SectionHeader'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const Groups = ({
	trip: {
		name,
		jsonData: { groups, trekOrClimb },
	},
}: Props) => {
	if (!groups) return <></>

	const hasFacebookGroups =
		groups.filter((group) => group.includes('www.facebook.com')).length > 0

	return (
		<div id="groups-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`${name} Links`}
				subtitle={`useful websites, Groups and communities`}
				section={Types.App.DataTypes.FeedbackSection.GROUPS}
			/>
			<p>Groups / links with more info on the {name} route.</p>
			{hasFacebookGroups && (
				<p>
					Use facebook groups to find up to date info, plan trips and find{' '}
					{trekOrClimb === 'TREK' ? 'trekking' : 'climbing'} buddies.
				</p>
			)}
			<div id="groups-items">
				{groups.map((item, key) => {
					return (
						<a className="groups-item" key={key} href={item}>
							{item}
						</a>
					)
				})}
			</div>
		</div>
	)
}

export default Groups
